
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class B2CGstReportSummaryGrid extends Serenity.EntityGrid<B2CGstReportSummaryRow, any> {
        protected getColumnsKey() { return B2CGstReportSummaryColumns.columnsKey; }
        protected getDialogType() { return B2CGstReportSummaryDialog; }
        protected getIdProperty() { return B2CGstReportSummaryRow.idProperty; }
        protected getInsertPermission() { return B2CGstReportSummaryRow.insertPermission; }
        protected getLocalTextPrefix() { return B2CGstReportSummaryRow.localTextPrefix; }
        protected getService() { return B2CGstReportSummaryService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}